import { createFeatureSelector } from '@ngrx/store';
import { BasketState, BASKET_FEATURE_KEY } from './basket.reducer';

export const getBasketState =
  createFeatureSelector<BasketState>(BASKET_FEATURE_KEY);
